import script from "./LabelText.vue?vue&type=script&setup=true&lang=js"
export * from "./LabelText.vue?vue&type=script&setup=true&lang=js"

import "./LabelText.vue?vue&type=style&index=0&id=aab48c36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aab48c36"]])

export default __exports__